module.exports = __webpack_public_path__ + "img/next@2x.79e59dba.png";